import * as filterKeyMap from '@intelligence/components/Filter/FilterBase/_config';

import type { IGenretorValue } from '@intelligence/v3/utils/genre';

interface IBuildResetFilterValueParams {
  resetBaseValue?: any;
  fallbackResetValue?: any;
  filterKeyList?: string[];
  rangeTimeComponentDefault?: any;
  releaseTimeComponentDefault?: any;
  genreComponentDefault?: IGenretorValue | null;
}

const hasConcreteArrayValue = (value: any) => {
  if (!Array.isArray(value)) {
    return false;
  }

  return value.some((item) => item !== '' && item != null);
};

export const buildResetFilterValue = (params: IBuildResetFilterValueParams) => {
  const {
    filterKeyList = [],
    resetBaseValue,
    fallbackResetValue,
    rangeTimeComponentDefault,
    releaseTimeComponentDefault,
    genreComponentDefault,
  } = params;

  let nextResetFilterValue = {
    ...(fallbackResetValue || {}),
    ...(resetBaseValue || {}),
  };

  if (filterKeyList.includes(filterKeyMap.RANGE_TIME)) {
    const defaultRangeTimeType = nextResetFilterValue?.[filterKeyMap.RANGE_TIME]?.type;
    const currentRangeTimeValue = nextResetFilterValue?.[filterKeyMap.RANGE_TIME]?.value;

    nextResetFilterValue = {
      ...nextResetFilterValue,
      [filterKeyMap.RANGE_TIME]: {
        ...nextResetFilterValue?.[filterKeyMap.RANGE_TIME],
        type: defaultRangeTimeType,
        value: hasConcreteArrayValue(currentRangeTimeValue)
          ? currentRangeTimeValue
          : rangeTimeComponentDefault?.[defaultRangeTimeType],
      },
    };
  }

  if (filterKeyList.includes(filterKeyMap.RELEASE_TIME)) {
    const currentReleaseTimeValue = nextResetFilterValue?.[filterKeyMap.RELEASE_TIME]?.value;

    nextResetFilterValue = {
      ...nextResetFilterValue,
      [filterKeyMap.RELEASE_TIME]: {
        type: 'date',
        value: hasConcreteArrayValue(currentReleaseTimeValue)
          ? currentReleaseTimeValue
          : releaseTimeComponentDefault?.date,
      },
    };
  }

  if (filterKeyList.includes(filterKeyMap.GENRETOR_WITH_SEGMENT)) {
    nextResetFilterValue = {
      ...nextResetFilterValue,
      [filterKeyMap.GENRETOR_WITH_SEGMENT]: {
        ...nextResetFilterValue?.[filterKeyMap.GENRETOR_WITH_SEGMENT],
        ...genreComponentDefault,
      },
    };
  }

  return nextResetFilterValue;
};
